import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RadioFieldGroup } from '@/components/functional/Form/RadioField';
import { FieldLabel } from '@/components/ui/Form/FieldLabel';
import { Text } from '@/components/ui/Typography/Body/Text';
import { REQUEST_DIVISION_CANDIDATE_CLIENT, REQUEST_DIVISION_CANDIDATE_PRO, } from '@/utils/resources/registration/requestDivision';
import { validateUseType } from '@/utils/validate/resources/registration/registration';
/** 選択項目 */
const divisionFieldItems = [
    {
        label: REQUEST_DIVISION_CANDIDATE_CLIENT.short,
        value: REQUEST_DIVISION_CANDIDATE_CLIENT.value,
    },
    {
        label: REQUEST_DIVISION_CANDIDATE_PRO.short,
        value: REQUEST_DIVISION_CANDIDATE_PRO.value,
    },
];
/**
 * 新規登録画面 利用方法フォーム
 * @param props
 * @returns
 */
export const RegistrationRequestDivisionField = (props) => {
    const { className = '', name } = props;
    return (_jsx(FieldLabel, Object.assign({ className: className, labelText: _jsxs(_Fragment, { children: ["\u5229\u7528\u65B9\u6CD5", _jsx(Text, Object.assign({ size: 'xs', tagName: 'span' }, { children: "\u3054\u5E0C\u671B\u306E\u5229\u7528\u65B9\u6CD5\u3092\u3054\u9078\u629E\u304F\u3060\u3055\u3044" }))] }), labelTextClassName: 'flex flex-wrap items-center gap-x-8 w-full' }, { children: _jsx(RadioFieldGroup, { className: 'w-full sm:w-1/2 justify-start sm:justify-center', formGroupClassName: clsx('sm:!flex-row !flex-nowrap !items-start sm:items-center !justify-start sm:justify-center  w-full', className), isNumberValue: true, items: divisionFieldItems, name: name, row: false, validate: validateUseType }) })));
};
